import { HTMLAttributes } from 'react'

import Container from '@/components/base/Container'
import Form from '@/components/base/Form'
import Grid from '@/components/base/Grid'
import Motion from '@/components/base/Motion'
import Typography from '@/components/base/Typography'
import Spacer from '@/components/sections/Spacer'

import { simpleAnimation } from './animations'

export type ContactFormProps = HTMLAttributes<HTMLElement> &
  Partial<{
    theme?: 'dark' | 'light'
    className: string
    title: string
    description: string
    title_2: string
    description_2: string
    form_id: string
    form: {
      button: {
        text: string
      }
      fields: any[]
    }
  }>

const ContactForm = ({
  className,
  title,
  description,
  title_2,
  description_2,
  form_id,
  form,
  theme,
  ...props
}: ContactFormProps) => {
  return (
    <Motion animation={simpleAnimation}>
      {(motionRef) => (
        <section ref={motionRef} className={className} {...props}>
          <Container data-motion-block id="form">
            <Grid>
              <div className="col-span-4 md:col-span-6 lg:col-span-4 lg:col-start-2">
                <div className="flex flex-col gap-y-[3rem]">
                  {title ? (
                    <Typography
                      variant="h1"
                      component="h2"
                      className="uppercase"
                    >
                      {title}
                    </Typography>
                  ) : null}
                  {description ? (
                    <Typography variant="body" data-motion-paragraph>
                      {description}
                    </Typography>
                  ) : null}
                </div>
                <Spacer variant="lg" theme={theme} />
                <div className="flex flex-col gap-y-[1.5rem]">
                  {title_2 ? (
                    <Typography
                      variant="h4"
                      component="h4"
                      className="!text-[1.8rem] uppercase"
                    >
                      {title_2}
                    </Typography>
                  ) : null}
                  {description_2 ? (
                    <Typography variant="body" data-motion-paragraph>
                      {description_2}
                    </Typography>
                  ) : null}
                </div>
              </div>
              <div className="col-span-4 mt-[4.8rem] md:col-span-6 lg:col-span-5 lg:col-start-7 lg:mt-0">
                <Form
                  form_id={form_id}
                  fields={form?.fields}
                  submit={form?.button?.text}
                />
              </div>
            </Grid>
          </Container>
        </section>
      )}
    </Motion>
  )
}

export default ContactForm
